<div class="step-container registration-success-page">
  <div class="registration-content">
    <h5 class="registration-success-page-title">
      {{ 'fgbcl.registration.success.page.title' | translate: { fgbdefault: 'Processed Successfully' } }}
    </h5>
    @switch (wizardType) {
      @case (wizardTypes.ChildRegistration) {
        <ng-container *ngIf="checkoutItems?.length > 0">
          <ng-container *ngTemplateOutlet="summaryTemplate; context: { $implicit: checkoutItems }"></ng-container>
          <a class="btn back-btn mt-3" [routerLink]="['/guardians']">{{
            'fgbcl.registration.success.page.back.button' | translate
          }}</a>
        </ng-container>
      }
      @default {
        <ng-container *ngTemplateOutlet="defaultMessage"></ng-container>
      }
    }
  </div>

  <ng-template #defaultMessage>
    <p class="message" [innerHTML]="'fgbcl.registration.success.page.account.message' | translate | markdownTranslate"></p>
    <a class="btn back-btn" [routerLink]="['/']">{{ 'fgbcl.registration.success.page.login.button' | translate }}</a>
  </ng-template>
</div>

<!-- LOADING SPINNER  -->
<ng-template #loading>
  <div class="text-center p-4">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>

<ng-template #summaryTemplate let-items>
  <h5 class="registration-success-page-summary-title">
    {{ 'registration.success.page.summary.title' | translate: { fgbdefault: 'Summary' } }}
  </h5>
  <div class="registration-success-basket-container">
    <div class="registration-success-basket-item" *ngFor="let item of items">
      <span class="registration-success-basket-item-desc"
        ><span class="basket-label">{{ item.description }}</span> <span class="basket-item"> - {{ item.name }}</span></span
      >
      <span class="registration-success-basket-item-cost"
        ><span class="basket-label">{{ 'registration.payment.cost.label' | translate: { fgbdefault: 'Cost' } }}</span>
        @if (item.unitPrice === 0) {
          {{ 'fgbcl.registration.payment.free.label' | translate: { fgbdefault: 'FREE' } }}
        } @else {
          {{ (item.qty * item.unitPrice) / 100 | FortressCurrencyPipe }}
        }
      </span>
    </div>
  </div>
</ng-template>
